import parse, { domToReact, attributesToProps } from 'html-react-parser';
import { Element } from 'domhandler/lib/node';
import { Link } from 'react-router-dom';
import * as React from 'react';

export default class htmlParser {
    /**
     * Decodes html characters, such as `&lt;` to `<`
     * see: https://stackoverflow.com/questions/1912501/unescape-html-entities-in-javascript/34064434#34064434
     * @param input 
     * @returns string
     */
    static htmlDecode = (input: string): string => {

        const doc = new DOMParser().parseFromString(input, "text/html");

        const output = doc.documentElement.textContent ?? "";

        return output;

    }

    /**
     * Takes a parameter name and URL and returns a value
     * see: https://www.arungudelli.com/tutorial/javascript/get-query-string-parameter-values-from-url-using-javascript/
     * 
     * @param parameterName 
     * @param url 
     * @returns string
     */
    static getParameterValueFromUrl = (parameterName: string, url: string): string => {

        const searchParams = new URLSearchParams(url);

        let value = "";

        if (searchParams.has(parameterName)) {

            value = searchParams.get(parameterName) ?? "";
        }

        return value;
    }

    /**
     * Gets an updated URL by removing a parameter
     * 
     * @param parameterName Parameter to remove
     * @param pathname      pathname used in the url
     * @param search        querystring of a url
     * @returns 
     */
    static removeParameterFromUrl = (parameterName: string, pathname: string, search: string): string => {

        let modifiedUrl = pathname;

        const searchParams = new URLSearchParams(search);

        searchParams.delete(parameterName);

        const newSearch = searchParams.toString();

        if (newSearch) {
            modifiedUrl = modifiedUrl + "?" + newSearch;
        }

        return modifiedUrl;

    }

    /**
     * Removes the querystring from url path
     * 
     * @param path 
     * @returns 
     */
    static removeQuerystringFromPath = (path: string): string => {

        let newPath = "";

        // split by the first question mark
        const arrPath = path.split("?", 1);

        newPath = arrPath[0];
        
        return newPath;

    }

    static htmlToJSX = (html: string) => {
        const options = {
            replace: (domNode: Element) => {
                if (domNode.type === 'tag' && domNode.name === 'a') {
                    const href: string = domNode?.attribs?.href ?? '';
                    // Leave the tag as-is if this isn't a CMS URL or
                    // it is and links to the admin or a media upload
                    if (
                        !href.startsWith(process.env.CMS_URL ?? '') || 
                        href.includes('/wp-admin') || 
                        href.includes('/wp-content/uploads')
                    ) {
                        return domNode;
                    }

                    const props = attributesToProps(domNode.attribs);
                    delete props.href;
                    const relativeHref = href.replace(process.env.CMS_URL ?? '', '');
                    return (
                        <Link to={relativeHref} {...props}>
                            {domToReact(domNode.children, options)}
                        </Link>
                    );
                }

                return domNode;
            }
        };
        return parse(html, options);
    }

}